import backendV2Service from './backend-v2.service';

/**
 * Calendar Type interface
 * Represents a calendar type entity from the backend
 * Note: Backend returns snake_case but humps transforms it to camelCase
 */
export interface CalendarType {
  id: number;
  name: string;
  startDay: number;
  startMonth: number;
  endDay: number;
  endMonth: number;
  schoolId: number | null;
  deprecatedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Calendar Type Service
 * Handles all calendar type related API calls using Backend V2
 */
export default {
  /**
   * Get all calendar types
   * @param includeDeprecated - Whether to include deprecated (legacy) calendar
   * types. Defaults to true so existing callers keep seeing every type.
   * @returns Promise with array of calendar types
   */
  findAll: (includeDeprecated = true) => backendV2Service.get<CalendarType[]>(
    '/calendar-types',
    { params: { include_deprecated: includeDeprecated } },
  ),

  /**
   * Get a single calendar type by ID
   * @param id - Calendar type ID
   * @returns Promise with calendar type data
   */
  findOne: (id: number) => backendV2Service.get<CalendarType>(`/calendar-types/${id}`),
};
